import PortalIdParser from 'PortalIdParser';

/**
 * Appcues is a tool that allows us to create custom onboarding flows for our users.
 * This integration is a Flywheel specific feature only available on Portal 53 (and QA).
 */

const portalId = PortalIdParser.get();
const HUBSPOT_PORTAL_ID_QA = 99535353;
const HUBSPOT_PORTAL_ID = 53;
const isAppCuesEnabled = () => {
  return portalId === HUBSPOT_PORTAL_ID_QA || portalId === HUBSPOT_PORTAL_ID;
};
const injectAppCuesScript = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://fast.appcues.com/220066.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Appcues script'));
    document.head.appendChild(script);
  });
};
export const setupAppCues = auth => {
  if (!isAppCuesEnabled()) {
    return;
  }
  injectAppCuesScript().then(() => {
    const {
      user
    } = auth;

    //@ts-expect-error untyped
    if (window.Appcues) {
      //@ts-expect-error untyped
      window.Appcues.identify(user.user_id, {
        createdAt: user.created_at,
        email: user.email,
        name: `${user.first_name} ${user.last_name}`,
        locale: user.locale,
        partner: user.partner,
        teams: user.teams.map(team => team.name).join(', ')
      });

      // @ts-expect-error untyped
      window.AppcuesSettings = {
        enableURLDetection: true
      };
    } else {
      console.error('Appcues not found');
    }
  }).catch(error => {
    console.error('Failed to setup Appcues:', error);
  });
};